export enum MessageEvent {
  /** The `OnMessageSent` event is emitted when a message is sent. */
  OnMessageSent = 'OnMessageSent',
  /** The `OnMessageResponse` event is emitted when a message is received. */
  OnMessageResponse = 'OnMessageResponse',
  /** The `OnMessageUpdate` event is emitted when a message is updated. */
  OnMessageUpdate = 'OnMessageUpdate',
}
